// SPDX-License-Identifier: AGPL-3.0-or-later

import {SettingsSection} from '@app/features/guild/components/modals/guild_tabs/guild_overview_tab/components/SettingsSection';
import type {FormInputs} from '@app/features/guild/utils/guild_tabs/GuildOverviewTabUtils';
import {Switch} from '@app/features/ui/components/form/Switch';
import {Trans, useLingui} from '@lingui/react/macro';
import type React from 'react';
import type {UseFormReturn} from 'react-hook-form';
import {Controller} from 'react-hook-form';
export const OwnerCrownSection: React.FC<{
	form: UseFormReturn<FormInputs>;
	canManageGuild: boolean;
}> = ({form, canManageGuild}) => {
	const {t} = useLingui();
	return (
		<SettingsSection
			title={<Trans>Community Owner Crown</Trans>}
			description={<Trans>Configure whether the crown icon is shown next to the community owner</Trans>}
		>
			<Controller
				name="hide_owner_crown"
				control={form.control}
				render={({field}) => (
					<Switch
						label={t`Hide community owner crown`}
						description={t`When enabled, the crown icon next to the community owner is hidden across the member list and other surfaces. When disabled (default), the crown is shown.`}
						value={field.value ?? false}
						onChange={field.onChange}
						disabled={!canManageGuild}
					/>
				)}
			/>
		</SettingsSection>
	);
};
